import styled from "@emotion/styled";
import Skeleton from "@mui/material/Skeleton";

const DubbedSkeleton = () => {
  return (
    <Section>
      <Profile>
        <Skeleton
          variant="circular"
          width={40}
          height={40}
          style={{ backgroundColor: "#333333" }}
        />
      </Profile>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        style={{ backgroundColor: "#333333" }}
      />
      <Script>
        <Skeleton
          variant="text"
          width="70%"
          height={100}
          style={{ backgroundColor: "#333333" }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={100}
          style={{ backgroundColor: "#333333" }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={100}
          style={{ backgroundColor: "#333333" }}
        />
      </Script>
    </Section>
  );
};

const Section = styled.div`
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: black;
`;

const Profile = styled.div`
  display: flex;
  width: 100%;
  height: 88px;
  padding: 24px 20px;
`;

const ProfileInfo = styled.div`
  width: 100%;
  height: 100%;
  margin-left: 9px;
`;

const Script = styled.div`
  padding: 0 14px;
`;

export default DubbedSkeleton;
